var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 2.44772 0.447715 2 1 2H5V4H1C0.447715 4 0 3.55228 0 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 14.4477 0.447715 14 1 14H5V16H1C0.447715 16 0 15.5523 0 15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9C24 9.55228 23.5523 10 23 10L19 10L19 8L23 8C23.5523 8 24 8.44772 24 9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H23C23.5523 2 24 2.44772 24 3C24 3.55228 23.5523 4 23 4H8V2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H23C23.5523 14 24 14.4477 24 15C24 15.5523 23.5523 16 23 16H8V14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10L1 10C0.447715 10 3.91405e-08 9.55228 8.74228e-08 9C1.35705e-07 8.44771 0.447715 8 1 8L16 8L16 10Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 2,
    height: 6,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 2,
    height: 6,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-180 17 12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.8357b447ffe2b0a110f8947733bdbc2e.svg";
export { ForwardRef as ReactComponent };